import React, { Component } from 'react';
import { Modal, Button, Form, Row, Col, Tab, Tabs } from 'react-bootstrap';

export class AddService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Service details
            catalog: props.catalog || "",
            category: props.category || "",
            description: props.description || "",
            duration: props.duration || 0,
            
            // Retail pricing (organized by vehicle size)
            retailPrices: props.retailPrices || { L: 0, M: 0, S: 0 },
            
            // Wholesale pricing (organized by vehicle size)
            wholesalePrices: props.wholesalePrices || { L: 0, M: 0, S: 0 },
            
            // Form state
            errors: {},
            activeTab: 'retail',
            
            // Auto-calculation features
            useWholesaleMargin: false,
            wholesaleMargin: 15, // Default 15% margin
            
            // Wholesale availability
            enableWholesale: false
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show && this.props.show) {
            if (this.props.action === "add") {
                // For adding new service, start with empty fields
                this.setState({
                    catalog: "",
                    category: "",
                    description: "",
                    duration: 0,
                    retailPrices: { L: 0, M: 0, S: 0 },
                    wholesalePrices: { L: 0, M: 0, S: 0 },
                    enableWholesale: false,
                    errors: {}
                });
            } else {
                // For updating existing service, populate with existing data
                const hasWholesalePrices = this.props.wholesalePrices && 
                    (this.props.wholesalePrices.L > 0 || this.props.wholesalePrices.M > 0 || this.props.wholesalePrices.S > 0);
                
                this.setState({
                    catalog: this.props.catalog || "",
                    category: this.props.category || "",
                    description: this.props.description !== "Service" ? this.props.description : "",
                    duration: this.props.duration || 0,
                    retailPrices: this.props.retailPrices || { L: 0, M: 0, S: 0 },
                    wholesalePrices: this.props.wholesalePrices || { L: 0, M: 0, S: 0 },
                    enableWholesale: hasWholesalePrices,
                    errors: {}
                });
            }
        }
    }

    handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        
        if (type === 'checkbox') {
            this.setState({
                [name]: checked,
                errors: { ...this.state.errors, [name]: '' }
            });
        } else {
            this.setState({
                [name]: value,
                errors: { ...this.state.errors, [name]: '' }
            });
        }
    };

    handlePriceChange = (priceType, vehicleSize, value) => {
        const priceKey = `${priceType}Prices`;
        const newPrices = { 
            ...this.state[priceKey],
            [vehicleSize]: parseFloat(value) || 0
        };
        
        this.setState({
            [priceKey]: newPrices
        });

        // Auto-calculate wholesale if enabled and this is a retail price change
        if (this.state.useWholesaleMargin && priceType === 'retail') {
            const wholesalePrice = (parseFloat(value) || 0) * (1 - this.state.wholesaleMargin / 100);
            const newWholesalePrices = {
                ...this.state.wholesalePrices,
                [vehicleSize]: Math.round(wholesalePrice * 100) / 100
            };
            this.setState({ wholesalePrices: newWholesalePrices });
        }
    };

    calculateAllWholesalePrices = () => {
        const margin = this.state.wholesaleMargin / 100;
        const newWholesalePrices = {};
        
        Object.keys(this.state.retailPrices).forEach(size => {
            const retailPrice = this.state.retailPrices[size] || 0;
            newWholesalePrices[size] = Math.round(retailPrice * (1 - margin) * 100) / 100;
        });
        
        this.setState({ 
            wholesalePrices: newWholesalePrices,
            enableWholesale: true 
        });
    };

    validateForm = () => {
        const errors = {};
        
        //console.log("=== VALIDATION DEBUG ===");
        /*console.log("Current state:", {
            category: this.state.category,
            description: this.state.description,
            duration: this.state.duration,
            retailPrices: this.state.retailPrices
        }); */
        
        if (!this.state.category || this.state.category.trim() === "" || this.state.category === "Category") {
            errors.category = "Please enter a category";
            //console.log("Category validation failed:", this.state.category);
        }
        
        if (!this.state.description || this.state.description.trim() === "" || this.state.description === "Service") {
            errors.description = "Description is required";
            //console.log("Description validation failed:", this.state.description);
        }
        
        if (!this.state.duration || this.state.duration <= 0) {
            errors.duration = "Duration must be greater than 0";
            //console.log("Duration validation failed:", this.state.duration);
        }
        
        // Validate retail prices
        const retailPrices = this.state.retailPrices;
        if (!retailPrices.L || retailPrices.L <= 0) {
            errors.retailL = "Large retail price is required";
            //console.log("Retail L validation failed:", retailPrices.L);
        }
        if (!retailPrices.M || retailPrices.M <= 0) {
            errors.retailM = "Medium retail price is required";
            //console.log("Retail M validation failed:", retailPrices.M);
        }
        if (!retailPrices.S || retailPrices.S <= 0) {
            errors.retailS = "Small retail price is required";
            //console.log("Retail S validation failed:", retailPrices.S);
        }

        //console.log("Validation errors:", errors);
        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    handleSubmit = () => {
        //console.log("=== MODAL SUBMIT DEBUG ===");
        //console.log("Action:", this.props.action);
        /*console.log("Form data:", {
            category: this.state.category,
            description: this.state.description,
            duration: this.state.duration,
            retailPrices: this.state.retailPrices,
            wholesalePrices: this.state.wholesalePrices
        });*/

        if (!this.validateForm()) {
            //console.log("Form validation failed");
            return;
        }

        const { category, description, duration, retailPrices, wholesalePrices } = this.state;

        //console.log("Calling parent function...");
        if (this.props.action === "add") {
            //console.log("Calling onAdd");
            this.props.onAdd(category, description, duration, retailPrices, wholesalePrices);
        } else if (this.props.action === "update") {
            //console.log("Calling onUpdate");
            this.props.onUpdate(category, description, duration, retailPrices, wholesalePrices);
        } else {
            //console.log("Unknown action:", this.props.action);
        }
    };

    renderPricingInputs = (priceType) => {
        const isRetail = priceType === 'retail';
        const prices = isRetail ? this.state.retailPrices : this.state.wholesalePrices;
        const label = isRetail ? 'Retail' : 'Wholesale';
        const vehicleSizes = ['L', 'M', 'S'];
        const sizeLabels = { L: 'Large', M: 'Medium', S: 'Small' };

        return (
            <Row>
                {vehicleSizes.map(size => (
                    <Col md={4} key={size}>
                        <Form.Group>
                            <Form.Label>{label} Price - {sizeLabels[size]} Vehicle</Form.Label>
                            <Form.Control
                                type="number"
                                step="0.01"
                                min="0"
                                value={prices[size] || ''}
                                onChange={(e) => this.handlePriceChange(priceType, size, e.target.value)}
                                isInvalid={!!this.state.errors[`${priceType}${size}`]}
                                placeholder="0.00"
                                disabled={!isRetail && !this.state.enableWholesale}
                            />
                            <Form.Control.Feedback type="invalid">
                                {this.state.errors[`${priceType}${size}`]}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                ))}
            </Row>
        );
    };

    calculateMargin = (retailPrice, wholesalePrice) => {
        if (!retailPrice || retailPrice <= 0) return 0;
        return Math.round(((retailPrice - wholesalePrice) / retailPrice) * 100);
    };

    render() {
        const { show, onHide, action } = this.props;
        const modalTitle = action === "add" ? "Add Service" : "Update Service";

        return (
            <Modal show={show} onHide={onHide} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    <Form>
                        {/* Service Details */}
                        <Row className="mb-4">
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Category</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="category"
                                        value={this.state.category}
                                        onChange={this.handleInputChange}
                                        isInvalid={!!this.state.errors.category}
                                        placeholder="Enter service category"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {this.state.errors.category}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={5}>
                                <Form.Group>
                                    <Form.Label>Service Description</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="description"
                                        value={this.state.description}
                                        onChange={this.handleInputChange}
                                        isInvalid={!!this.state.errors.description}
                                        placeholder="Enter service description"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {this.state.errors.description}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Duration (Days)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        min="0.1"
                                        step="0.1"
                                        name="duration"
                                        value={this.state.duration}
                                        onChange={this.handleInputChange}
                                        isInvalid={!!this.state.errors.duration}
                                        placeholder="Days"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {this.state.errors.duration}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Retail Pricing */}
                        <Row className="mb-4">
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Retail Price - Large</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        value={this.state.retailPrices.L || ''}
                                        onChange={(e) => this.handlePriceChange('retail', 'L', e.target.value)}
                                        isInvalid={!!this.state.errors.retailL}
                                        placeholder="0.00"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {this.state.errors.retailL}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Retail Price - Medium</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        value={this.state.retailPrices.M || ''}
                                        onChange={(e) => this.handlePriceChange('retail', 'M', e.target.value)}
                                        isInvalid={!!this.state.errors.retailM}
                                        placeholder="0.00"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {this.state.errors.retailM}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Retail Price - Small</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        value={this.state.retailPrices.S || ''}
                                        onChange={(e) => this.handlePriceChange('retail', 'S', e.target.value)}
                                        isInvalid={!!this.state.errors.retailS}
                                        placeholder="0.00"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {this.state.errors.retailS}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Wholesale Pricing */}
                        <Row className="mb-4">
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Wholesale Price - Large</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        value={this.state.wholesalePrices.L || ''}
                                        onChange={(e) => this.handlePriceChange('wholesale', 'L', e.target.value)}
                                        placeholder="0.00"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Wholesale Price - Medium</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        value={this.state.wholesalePrices.M || ''}
                                        onChange={(e) => this.handlePriceChange('wholesale', 'M', e.target.value)}
                                        placeholder="0.00"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Wholesale Price - Small</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        value={this.state.wholesalePrices.S || ''}
                                        onChange={(e) => this.handlePriceChange('wholesale', 'S', e.target.value)}
                                        placeholder="0.00"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        CANCEL
                    </Button>
                    <Button variant="primary" onClick={this.handleSubmit}>
                        {action === "add" ? "ADD SERVICE" : "UPDATE SERVICE"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}